module.exports = __webpack_public_path__ + "static/media/beaverton-small-placeholder.d7a3a61b.webp";